module.exports = __webpack_public_path__ + "media/svg/flechevideo-09b744e2.svg";